import { CSSProperties } from "react";
import { Button } from "antd";
import styled from "styled-components";
import theme from "styles/theme";

export const FormAddPlate = styled.div`
  display: flex;
  align-items: center;
  margin: auto;
  margin-bottom: -20px;
  gap: 3px;

  .ant-form-item-label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    padding: 0;
  }

  .ant-form-item-control-input-content {
    color: ${(props) => props.theme["@primary-color-brand"]};
    width: 31%;
    display: flex;
    align-items: center;
  }
`;

export const AddButtonPlate = styled(Button)`
  outline: none;
  border: none;
  box-shadow: none;
  float: left;
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.colors.text};
  :hover,
  :focus {
    color: ${(props) => props.theme["@primary-color-brand"]};
  }
  .addButtonTrailersPlates {
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
`;

export const InputCustomPlate = (plateFormatType?: 0 | 1 | 2): CSSProperties => ({
  textTransform: "uppercase",
  height: theme["@height-input-lg"],
  width: plateFormatType === 1 ? "140px" : plateFormatType === 2 ? "130px" : "120px",
  padding: plateFormatType === 1 ? "0 12px" : "0 8px",
  letterSpacing: plateFormatType === 1 ? "1px" : "0.5px",
  marginRight: "3px",
});
